// Module
var code = `<div class="dropDownSideBar" on-mousedown="@this.onMouseDown(event)">
    <div class="dropDownSideBar-header">
        <div class="dropDownSideBar-header-text">{{{.headerLocalText}}}</div>

        <div class="dropDownSideBar-header-buttonSector">
            <terceraButton name="closeCrossBtn" SVG="true" terceraButtonStyle="js-closeWindowBtn" visible="{{.closeBtnVisible}}" on-btnClick="onCloseClick" />
        </div>
    </div>

    <div class="dropDownSideBar-body">
        {{#if .whichPanel.Alert}}
            <alertPanelSideBar SideBarPanelRef="{{.SideBarPanelRef}}" on-updateHeader="onUpdateHeader" />
            {{elseif .whichPanel.Notifications}}
            <notificationsPanelSideBar SideBarPanelRef="{{.SideBarPanelRef}}" />
            {{elseif .whichPanel.VideoWidget}}
            <videoWidgetPanelSideBar SideBarPanelRef="{{.SideBarPanelRef}}" />
        {{/if}}

    </div>
</div>`;
// Exports
export default code;